export type PasswordChecks = {
  minLength: boolean;
  maxLength: boolean;
  lowercase: boolean;
  uppercase: boolean;
  number: boolean;
  symbol: boolean;
  noSpaces: boolean;
  valid: boolean;
};

export const minPasswordLength = 8;
export const maxPasswordLength = 128;
const symbolPattern = /[!@#$%^&*()_\-+=[\]{};:'"\\|,.<>/?`~]/;

export function validatePassword(password: string): PasswordChecks {
  const checks = {
    minLength: password.length >= minPasswordLength,
    maxLength: password.length <= maxPasswordLength,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    symbol: symbolPattern.test(password),
    noSpaces: !/\s/.test(password),
  };

  return {
    ...checks,
    valid: Object.values(checks).every(Boolean),
  };
}
